<div class="tab-body mat-elevation-z1">
  <div class="section-header">
    <h2>
      <mat-icon>view_module</mat-icon>
      Demos
    </h2>
    <div class="section-header-actions">
      <button mat-stroked-button color="primary" (click)="refreshAll()" [disabled]="isActionBusy(refreshActionKey()) || loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
      <button mat-flat-button color="primary" (click)="openCreateDemo()">Create Demo</button>
    </div>
  </div>

  <mat-form-field class="search-field" appearance="outline">
    <mat-label>Search demos...</mat-label>
    <input matInput [(ngModel)]="demosSearchTerm" (ngModelChange)="onDemosSearchTermChange()" placeholder="Search by ID, title, type, or availability">
    <button mat-icon-button matSuffix *ngIf="demosSearchTerm" (click)="demosSearchTerm = ''; onDemosSearchTermChange()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <div class="loading-overlay" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <table class="admin-table" *ngIf="!loading">
    <thead>
      <tr>
        <th>ID</th>
        <th>Title</th>
        <th>Type</th>
        <th>Available</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of getPaginatedItems('demos', getDisplayedDemos())">
        <td>{{ item.id }}</td>
        <td>{{ item.demo_title }}</td>
        <td>{{ item.demo_type }}</td>
        <td>{{ item.available }}</td>
        <td>
          <button mat-icon-button color="primary" type="button" matTooltip="Edit" (click)="openEditDemo(item)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" type="button" matTooltip="Delete" [disabled]="isActionBusy(demoDeleteActionKey(item.id))" (click)="deleteDemo(item)" class="delete-btn">
            <mat-spinner *ngIf="isActionBusy(demoDeleteActionKey(item.id))" diameter="16" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(demoDeleteActionKey(item.id))">delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="empty-state" *ngIf="getDisplayedDemos().length === 0 && !loading">
    <mat-icon>search_off</mat-icon>
    <p>No demos match your search.</p>
  </div>

  <div class="pagination-row" *ngIf="getDisplayedDemos().length > 0 && !loading">
    <button mat-stroked-button type="button" (click)="goToPreviousPage('demos')" [disabled]="getCurrentPage('demos') === 1">Previous</button>
    <span>Page {{ getCurrentPage('demos') }} of {{ getTotalPages('demos', getDisplayedDemos().length) }}</span>
    <button mat-stroked-button type="button" (click)="goToNextPage('demos', getDisplayedDemos().length)" [disabled]="getCurrentPage('demos') >= getTotalPages('demos', getDisplayedDemos().length)">Next</button>
  </div>

  <div class="modal-backdrop" *ngIf="isDemoEditorVisible">
    <div class="modal-card mat-elevation-z8 editor-modal-card editor-modal-card--wide">
      <div class="modal-header">
        <div>
          <h3 class="editor-modal-title">
            <mat-icon>view_module</mat-icon>
            {{ editingDemoId ? 'Edit Demo' : 'Create Demo' }}
            <span class="entity-id" *ngIf="editingDemoId">ID: {{ editingDemoId }}</span>
          </h3>
          <p class="editor-modal-subtitle">Manage the demo record, files, and topic tags without leaving the list.</p>
        </div>
        <button mat-icon-button type="button" (click)="cancelDemoEdit()" aria-label="Close demo editor">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="modal-body editor-modal-body">
        <div class="demo-editor-section">
          <div class="form-row material-grid">
            <mat-form-field appearance="outline">
              <mat-label>Demo title</mat-label>
              <input matInput [(ngModel)]="demoForm.demo_title" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Demo type</mat-label>
              <mat-select [(ngModel)]="demoForm.demo_type">
                <mat-option value="Business">Business</mat-option>
                <mat-option value="Analytic">Analytic</mat-option>
                <mat-option value="Info">Info</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Available</mat-label>
              <mat-select [(ngModel)]="demoForm.available">
                <mat-option value="Y">Y</mat-option>
                <mat-option value="N">N</mat-option>
                <mat-option value="P">P</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Short description</mat-label>
              <input matInput [(ngModel)]="demoForm.short_description" />
            </mat-form-field>
          </div>

          <div class="demo-update-row">
            <button mat-flat-button color="primary" type="button" (click)="saveDemo()" [disabled]="isActionBusy(demoSaveActionKey()) || (editingDemoId && !isDemoFormDirty)">
              <mat-spinner *ngIf="isActionBusy(demoSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
              <span *ngIf="!isActionBusy(demoSaveActionKey())">{{ editingDemoId ? 'Update' : 'Create' }}</span>
            </button>
          </div>

          <div class="embedded-section" *ngIf="editingDemoId">
            <div class="section-header">
              <h2>Demo Files</h2>
              <button mat-icon-button color="primary" type="button" aria-label="Create Demo File" (click)="openCreateDemoFileForCurrentDemo()">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            <table class="admin-table">
              <thead>
                <tr>
                  <th>Label</th>
                  <th>Type</th>
                  <th>Directory</th>
                  <th>Filename</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="isCreatingDemoFile()">
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Label</mat-label>
                      <mat-select [(ngModel)]="demoFileForm.label">
                        <mat-option value="SQL Version">SQL Version</mat-option>
                        <mat-option value="Information">Information</mat-option>
                        <mat-option value="Python Version">Python Version</mat-option>
                        <mat-option value="Python-SQL Version">Python-SQL Version</mat-option>
                        <mat-option value="support2">support2</mat-option>
                        <mat-option value="Video">Video</mat-option>
                        <mat-option value="Read Only Python-SQL">Read Only Python-SQL</mat-option>
                        <mat-option value="R Version">R Version</mat-option>
                        <mat-option value="Read Only SQL">Read Only SQL</mat-option>
                        <mat-option value="support1">support1</mat-option>
                        <mat-option value="None">None</mat-option>
                        <mat-option value="Read Only Python">Read Only Python</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Type</mat-label>
                      <mat-select [(ngModel)]="demoFileForm.demo_type">
                        <mat-option value="notebook">notebook</mat-option>
                        <mat-option value="nbviewer">nbviewer</mat-option>
                        <mat-option value="web">Web</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Directory</mat-label>
                      <input matInput [(ngModel)]="demoFileForm.directory" [matAutocomplete]="createDirAuto" />
                      <mat-autocomplete #createDirAuto="matAutocomplete">
                        <mat-option *ngFor="let dir of getFilteredDirectories()" [value]="dir">{{ dir }}</mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Filename</mat-label>
                      <input matInput [(ngModel)]="demoFileForm.filename" [matAutocomplete]="createFileAuto"
                        (ngModelChange)="onGitHubFilenameSelected($event)" />
                      <mat-autocomplete #createFileAuto="matAutocomplete" (optionSelected)="onGitHubFilenameSelected($event.option.value)">
                        <mat-option *ngFor="let name of getFilteredFilenames()" [value]="name">{{ name }}</mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                  <td>
                    <button mat-icon-button color="primary" type="button" matTooltip="Create" [disabled]="isActionBusy(demoFileSaveActionKey())" (click)="saveDemoFile()">
                      <mat-spinner *ngIf="isActionBusy(demoFileSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelDemoFileEdit()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>

                <tr *ngFor="let item of getPaginatedItems('demoFiles', demoFilesForEditingDemo())">
                  <td *ngIf="!isEditingDemoFile(item)">{{ item.label }}</td>
                  <td *ngIf="isEditingDemoFile(item)">
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Label</mat-label>
                      <mat-select [(ngModel)]="demoFileForm.label">
                        <mat-option value="SQL Version">SQL Version</mat-option>
                        <mat-option value="Information">Information</mat-option>
                        <mat-option value="Python Version">Python Version</mat-option>
                        <mat-option value="Python-SQL Version">Python-SQL Version</mat-option>
                        <mat-option value="support2">support2</mat-option>
                        <mat-option value="Video">Video</mat-option>
                        <mat-option value="Read Only Python-SQL">Read Only Python-SQL</mat-option>
                        <mat-option value="R Version">R Version</mat-option>
                        <mat-option value="Read Only SQL">Read Only SQL</mat-option>
                        <mat-option value="support1">support1</mat-option>
                        <mat-option value="None">None</mat-option>
                        <mat-option value="Read Only Python">Read Only Python</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isEditingDemoFile(item)">{{ item.demo_type }}</td>
                  <td *ngIf="isEditingDemoFile(item)">
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Type</mat-label>
                      <mat-select [(ngModel)]="demoFileForm.demo_type">
                        <mat-option value="notebook">notebook</mat-option>
                        <mat-option value="nbviewer">nbviewer</mat-option>
                        <mat-option value="web">Web</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isEditingDemoFile(item)">{{ item.directory }}</td>
                  <td *ngIf="isEditingDemoFile(item)">
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Directory</mat-label>
                      <input matInput [(ngModel)]="demoFileForm.directory" [matAutocomplete]="editDirAuto" />
                      <mat-autocomplete #editDirAuto="matAutocomplete">
                        <mat-option *ngFor="let dir of getFilteredDirectories()" [value]="dir">{{ dir }}</mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isEditingDemoFile(item)">{{ item.filename }}</td>
                  <td *ngIf="isEditingDemoFile(item)">
                    <mat-form-field appearance="outline" class="cell-field">
                      <mat-label>Filename</mat-label>
                      <input matInput [(ngModel)]="demoFileForm.filename" [matAutocomplete]="editFileAuto"
                        (ngModelChange)="onGitHubFilenameSelected($event)" />
                      <mat-autocomplete #editFileAuto="matAutocomplete" (optionSelected)="onGitHubFilenameSelected($event.option.value)">
                        <mat-option *ngFor="let name of getFilteredFilenames()" [value]="name">{{ name }}</mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isEditingDemoFile(item)">
                    <button mat-icon-button color="primary" type="button" matTooltip="Edit" (click)="openEditDemoFile(item)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" type="button" matTooltip="Delete" [disabled]="isActionBusy(demoFileDeleteActionKey(item.label))" (click)="deleteDemoFile(item)" class="delete-btn">
                      <mat-spinner *ngIf="isActionBusy(demoFileDeleteActionKey(item.label))" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon *ngIf="!isActionBusy(demoFileDeleteActionKey(item.label))">delete</mat-icon>
                    </button>
                  </td>
                  <td *ngIf="isEditingDemoFile(item)">
                    <button mat-icon-button color="primary" type="button" matTooltip="Update" (click)="saveDemoFile()" [disabled]="isActionBusy(demoFileSaveActionKey()) || !isDemoFileFormDirty">
                      <mat-spinner *ngIf="isActionBusy(demoFileSaveActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelDemoFileEdit()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="pagination-row" *ngIf="demoFilesForEditingDemo().length > 0">
              <button mat-stroked-button type="button" (click)="goToPreviousPage('demoFiles')" [disabled]="getCurrentPage('demoFiles') === 1">Previous</button>
              <span>Page {{ getCurrentPage('demoFiles') }} of {{ getTotalPages('demoFiles', demoFilesForEditingDemo().length) }}</span>
              <button mat-stroked-button type="button" (click)="goToNextPage('demoFiles', demoFilesForEditingDemo().length)" [disabled]="getCurrentPage('demoFiles') >= getTotalPages('demoFiles', demoFilesForEditingDemo().length)">Next</button>
            </div>
          </div>

          <div class="embedded-section" *ngIf="editingDemoId">
            <div class="section-header">
              <h2>Demo Topics</h2>
            </div>

            <div class="topic-filter-row">
              <mat-form-field appearance="outline" class="topic-area-filter-field">
                <mat-label>Topic Area</mat-label>
                <mat-select [(ngModel)]="topicAreaFilterForDemo">
                  <mat-option [value]="null">All topic areas</mat-option>
                  <mat-option *ngFor="let area of topicAreas" [value]="area.id">
                    {{ area.topic_area_title }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="topic-search-field">
                <mat-label>Search topics to tag</mat-label>
                <input matInput [(ngModel)]="topicSearchTerm" placeholder="Type topic name" />
              </mat-form-field>
            </div>

            <div class="topic-search-results" *ngIf="filteredTopicsForEditingDemo().length > 0">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                class="topic-result-button"
                *ngFor="let topic of filteredTopicsForEditingDemo()"
                [matTooltip]="topicAreaTitleById(topic.topic_area)"
                [disabled]="isActionBusy(topicAddActionKey(topic.id))"
                (click)="addTopicToEditingDemo(topic)"
              >
                <mat-spinner *ngIf="isActionBusy(topicAddActionKey(topic.id))" diameter="16" class="btn-spinner"></mat-spinner>
                <mat-icon>add</mat-icon>
                {{ topic.topic_title }}
              </button>
            </div>

            <div class="topic-search-empty" *ngIf="filteredTopicsForEditingDemo().length === 0 && (topicSearchTerm.trim() || topicAreaFilterForDemo !== null)">
              No matching topics found.
            </div>

            <mat-chip-set class="topic-tag-list" aria-label="Demo topic tags">
              <mat-chip
                *ngFor="let item of demoTopicsForEditingDemo()"
                [removable]="!isActionBusy(topicRemoveActionKey(item.topic_id))"
                [matTooltip]="topicAreaTitleByTopicId(item.topic_id)"
                color="primary"
                selected
                (removed)="!isActionBusy(topicRemoveActionKey(item.topic_id)) && removeTopicFromEditingDemo(item)"
              >
                <mat-spinner *ngIf="isActionBusy(topicRemoveActionKey(item.topic_id))" diameter="16" class="btn-spinner"></mat-spinner>
                {{ topicTitleById(item.topic_id) }}
                <button matChipRemove aria-label="Remove topic">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
